module.exports = __webpack_public_path__ + "static/media/A2888-HELP_FAQ-17122020.69c166f1.pdf";